import { TransformDate } from '../../../shared/decorators/transform-date.decorator';

/**
 * Renew outbox record DTO
 */
export class RenewOutboxRecordDto {
	dispatchToken!: string;
	@TransformDate()
	leasedUntil?: Date;
}
